module.exports = __webpack_public_path__ + "c185bdd51d35a190626c84eb75ddea4d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/Images/SwiftImageIcons/Colored/1x/Coins.png
// module id = 1426
// module chunks = 0